module.exports = __webpack_public_path__ + "img/工单时效统计.6c72ea26.png";